import React from 'react'
import { Ranking } from './Ranking/Ranking';

export const GeneralLeaderboard = ({ ranking, loading }) => {
  return (
    <Ranking ranking={ranking} loading={loading} />
  )
}
